import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import TextEditor from 'shared/components/TextEditor/TextEditor';
import AbstractListerField from './AbstractListerField';
import CollapsingWrapper from 'shared/components/CollapsingWrapper/CollapsingWrapper';

export default class ListerTextEditor extends AbstractListerField {
  render() {
    const {
      errorText,
      onToggleOpen,
      open,
      title,
      tooltip,
      onChange,
      textEditorProps,
      value,
      disabled,
      id,
      ...other
    } = this.props;
    return (
      <CollapsingWrapper
        open={open}
        title={title}
        tooltip={tooltip}
        onToggleOpen={onToggleOpen}
        leftRightOpenMargin={-32}
        stickyTitle
        disabled={disabled}
        errorText={errorText}
        disabledTooltip="Can't modify Product Title and Description if there is no template"
      >
        <TextEditor id={id} onChange={onChange} {...textEditorProps} value={value} {...other} />
      </CollapsingWrapper>
    );
  }
}

ListerTextEditor.propTypes = {
  onChange: PropTypes.func,
  onFieldDelete: PropTypes.func,
  textEditorProps: PropTypes.object,
  required: PropTypes.bool,
};
